import { MDBModal } from 'mdb-react-ui-kit';

const Loader = ({ bgLightGray }: any) => {
    return (
        <MDBModal className={`modal-dialog-centered bg-${bgLightGray ? 'lightgray' : 'black'}`} open={true} tabIndex='-1' style={{ display: 'flex' }}>
            <div className="d-flex justify-content-center align-items-center w-100">
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </MDBModal>
    )
}

export default Loader;
